var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.7273,
    y: 70.7273,
    width: 70.7273,
    height: 70.7273,
    rx: 35.3636,
    transform: "rotate(180 70.7273 70.7273)",
    fill: "#751423"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_42673_43101",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 16,
    width: 39,
    height: 39
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7273,
    y: 54.7273,
    width: 38.7273,
    height: 38.7273,
    transform: "rotate(180 46.7273 54.7273)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_42673_43101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5909 19.228L46.7273 35.3643L30.5909 51.5007L27.7267 48.6365L40.9989 35.3643L27.7267 22.0922L30.5909 19.228Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.6bdaca8ea4fd0bc27d9f8958f14f1da3.svg";
export { ForwardRef as ReactComponent };